(function () {
  function fix() {
    var badges = document.querySelectorAll('.trustedsite-trustmark');
    badges.forEach(function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', el.getAttribute('title') || 'TrustedSite Certified');
      }
      if (!el.hasAttribute('data-a11y-keys')) {
        el.setAttribute('data-a11y-keys', 'true');
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
      }
      el.setAttribute('data-a11y-fixed', 'true');
    });
  }
  function start() {
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();